import React, {Component} from 'react'
import i18next from 'i18next';

import Timeline from './controls/timeline/Timeline'
import ChapterSlider from './controls/chapters/ChapterSlider'
import TableOfContents from './controls/toc/TableOfContents'
import {getCloud, getTranscript, incrementViewCount} from '../../defaults/resourceLinker'
import {generateClouds} from '../../defaults/cloudMaker'
import FullScreen from 'react-full-screen';
import {isIOS, isMobile} from 'react-device-detect';
import fscreen from 'fscreen';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import debounce from 'lodash/debounce'
import styled from '@emotion/styled'
import sv from '../../styles/styles'
import {__isAvailable, store} from "../../_helpers";
import {playerConstants} from "../../_constants/commons/playerConstants";
import {playerActions} from "../../_actions/player.actions";
import {LinearProgress} from "@material-ui/core";
import {withStyles} from "@material-ui/styles";
import Search from "./controls/search/Search";
import {prepareIndex, searchTranscript} from "../../defaults/transcript/transcriptSearcher";

// STYLE ##########################################################

const BOX_SHADOW_SIZE = 6;

const PlayerWrapper = styled('div')`
  position: relative;
  z-index: 101;
  height: ${props => props.height ? props.height : '100%'};
`;
PlayerWrapper.displayName = "PlayerWrapper";

const StyledPlayer = styled('div')`
  width: 100%;
  height: 100%;
  min-height: ${props => props.minHeight}px;
  position: relative;
  overflow: hidden;
  video {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
`;

const Video = styled('video')`
  background-color: #222;
  margin-top: ${props => props.marginTop}px;
  object-position: center top;
`;

const Thumbnail = styled('div')`
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  margin-top: ${props => props.marginTop}px;
  background-image: url("${props => props.thumbnailUri}");
  background-color: #333333;
  background-size: ${props => props.backgroundSize ? props.backgroundSize : "cover"};
  background-repeat: no-repeat;
  background-position: center top;
`;
Thumbnail.displayName = 'Thumbnail';

const Controls = styled(`div`)`
  ${sv.flexColumn};
  justify-content: center;
  align-items: center;
  transition: opacity .2s ease, bottom .1s ease, background 0.4s ease;
  width: 100%;
  height: ${props => props.isVideo ? "" : "100%"};  // fill all player when source is audio
  position: absolute;
  bottom: ${props => props.show ? '0px' : '-1000px'};
  z-index: 3;
  background: ${props => props.showGist ? 'rgba(0,0,0,.6)' : 'rgba(0,0,0,0)'};
  backdrop-filter: ${props => props.showGist ? 'blur(2.5px)' : 'none'};
  &:hover {
    background: ${props => props.showGist ? 'rgba(0,0,0,.8)' : 'rgba(0,0,0,0)'};
  }
  .timeline {
    ${sv.box};
    margin-top: auto;
    width: 100%;
    flex: 0;
    order: 3;
    padding: 0 ${sv.grid}px ${sv.grid}px ${sv.grid}px;
    
    background: ${props => 
      props.showSearchResults && props.showGist ? 'none': 
          props.showGist ? 'linear-gradient(to top, rgba(0,0,0,.6) 60%, rgba(0,0,0,0))' : 'linear-gradient(to top, rgba(0,0,0,.8) 75%, rgba(0,0,0,0))'};
    z-index: ${props => props.showSearchResults && props.showGist ? 1500 : ""};
  }
`;

const TooSmall = styled('div')`
  ${sv.flexCenter}
  position: absolute;
  z-index: 10;
  height: 100%;
  width: 100%;
  background: linear-gradient(to top, rgba(0,0,0,.8) 30%,rgba(0,0,0,0));
`;

const MobilePlayButton = styled(`div`)`
  background: rgba(0,0,0,.7);
  height: 50px;
  width: 80px;
  border-radius: 8px;
  ${sv.flexCenter};
`;

const ErrorMessage = styled(`div`)`
  color: ${sv.colors.subtleLight};
  background: ${sv.colors.darkerGray};
  cursor: pointer;
  ${sv.flexCenter};
  height:100%;
  padding: 0 30px;
`;

const LoaderContainer = styled(`div`)`
  ${sv.flexColumn};
  height:100%;
  div {
    z-index: ${props => props.videoIsPlaying ? '2' : '9'};
  }
`;

const DarkBackground = styled(`div`)`
  width: 100%;
  height: 100%;
  background: #00000040;
  position: absolute;
  z-index: 6;
`;

const SkipAction = styled(`div`)`
  width: 30.9%;
  @media(max-width: 450px) {
    width: 40.0%;
  }
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  position: absolute;
  z-index: 7;
  border-radius: ${props => props.left ? '0 90% 90% 0' : '90% 0 0 90%'};
  ${props => props.left ? 'left: 0;' : 'right: 0;'}
  ${props => props.visable ? 'opacity: 1; visibility: visible; transition: visibility 0.2s;' : 'visibility: hidden; opacity: 0; transition: visibility 0.5s, opacity 0.5s linear'}
`;

const SkipLabel = styled(`div`)`
  margin: 0 auto;
  color: white;
  text-align: center;
  user-select: none; 
  top: 50%;
  right: 50%;
  left: unset!important;
  position: absolute;
  padding: 8px;
  background: rgba(0, 0, 0, 0.24);
  border-radius: 6px;
  font-size: 24px;
  margin-right: ${props => props.right ? '-55px' : '0px'};
  margin-top: -36px;
  @media(max-width: 550px) {
    font-size: 20px;
  }
  @media(max-width: 450px) {
    font-size: 16px;
  }
  ${props => props.left ? 'left: 50%;' : 'right: 50%;'}
`;

const Arrows = styled(`div`)`
    font-weight: bold;
    font-size: 26px;
    @media(max-width: 550px) {
      font-size: 18px;
    }
    @media(max-width: 450px) {
      font-size: 24px;
    }
    animation-name: ${props => props.left ? 'ArrowsAnimatedLeft' : 'ArrowsAnimatedRight'};
    animation-duration:1.3s;
    animation-iteration-count:infinite;
    animation-timing-function:linear;
    @keyframes ArrowsAnimatedRight {
      0% {opacity: 1; transform: translateX(0px) scale(1);} 
      25%{opacity: 0; transform:translateX(10px) scale(0.9);} 
      26%{opacity: 0; transform:translateX(-10px) scale(0.9);} 
      55% {opacity: 1; transform: translateX(0px) scale(1);}
    }
    @keyframes ArrowsAnimatedLeft {
      0% {opacity: 1; transform: translateX(0px) scale(1);} 
      25%{opacity: 0; transform:translateX(-10px) scale(0.9);} 
      26%{opacity: 0; transform:translateX(10px) scale(0.9);} 
      55% {opacity: 1; transform: translateX(0px) scale(1);}
    }
`;

const CustomLinearProgress = withStyles({
  root: {
    height: '8px',
    margin: '8px',
    borderRadius: '4px'
  }
}) (LinearProgress);

// COMPONENT ##########################################################

const SEEK_SKIP = {
  SIZE: 10,             // seconds that can be skipped forward/backward
  FORWARD: 'forward',   // backward indicator
  BACKWARD: 'backward', // forward indicator
};

class Player extends Component {

  state = {
    position: 0,                    // the position where the video is currently playing/paused
    chapterCount: 3,                // sets the number of chapters
    currentChapter: 1,              // the chapter where the video currently sits at (based on chapterCount)
    videoIsPlaying: false,          // monitors whether video is playing
    isScrubbing: false,             // monitors whether video is being scrubbed
    videoLoaded: false,             // monitors whether video duration is ready; if yes loads timeline
    cloudInfo: null,                // holds the timecloud information; if yes allows timecloud
    clouds: [],
    wordTimelinePosition: null,     // show tick on timeline while hovering over a word
    isHovered: false,
    showTableOfContents: false,
    showGist: true,
    isFullScreen: false,
    isPortrait: false,
    peekControls: false,            // show controls when video is playing and mouse moves
    hideControlsTimeout: false,     // Initial 2sec timer on video play
    allowHideGist: true,            // allow hiding controls/gist.  If false, then the controls/gist will always show
    screenTooSmallForGist: false,
    showThumbnail: true,            // indicates whether the video has ever resumed
    iosPrePlay: false,              // if ios, flag that indicates whether the video has been played as least once
    isVideo: true,                  // indicates if the media is a video, as opposed to audio
    showSkipLeft: false,
    showSkipRight: false,
    seekSkipCounter: 0,             // tracks seek-skipped presses
    isShowFullControls: false,      // indicates whether the player should have 'full' controls
    isShowSemiFullControls: false,  // indicates whether the player should have 'semi-full' controls
    isShowDoubleTierControls: false,// indicates whether the player should show '2-tier' semi controls
    showBufferingLoader: false,     // tracks whether to show buffering-loader
    forceMediaReload: false,        // tracks if the media needs to re-loaded
    isSearchActive: false,          // tracks the state of the search feature
    searchQuery: '',                // current search query
    searchResults: null,            // holds the search results
    searchTimelinePositions: [],    // holds the search results positions
    searchCurrentHit: 1,            // holds the current search hit
    isSearchOngoing: false,         // tracks if search is currently ongoing
    transcriptData: null,           // caches search transcript data
    transcriptIndex: null,          // caches search transcript index
    isFetchingTranscript: false,    // tracks if transcript is being fetched
    isTranscriptError: false,       // tracks transcript fetch issue
  };

  constructor(props) {
    super(props);
    this.getGistPlayerRect = this.getGistPlayerRect.bind(this);

    this.onVideoPlay = this.onVideoPlay.bind(this);
    this.onVideoError = this.onVideoError.bind(this);
  }

  componentDidMount() {
    this.prepareVideoDuration();
    this.loadCloudInfo();
    this.checkSpaceForGist();

    if(this.props.isEmbedded) { this.hideZenChat(); }   // Hide ZenChat for embedded

    window.addEventListener("resize", this.checkSize, false);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const cloudInfoChanged = prevState.cloudInfo !== this.state.cloudInfo;
    if (this.playerContainer) {
      if (cloudInfoChanged) this.setClouds(this.state.cloudInfo.contents);
      this.checkSize();
    }

    // if not full-screen, remove body scroll lock if any
    if (!this.state.isFullScreen) {
      this.reEnableBodyScroll();
    }
  }

  checkSize = () => {
    this.rearrangeGistComponents();
    /*
     * Backup: Some clients update the container bounds a little slower, so re-invoke the arrangement after delay
     */
	  this.updatePlayerComponentSizeTimeout = setTimeout(() => this.rearrangeGistComponents(), 250);
  }

  rearrangeGistComponents = () => {
    if (this.playerContainer) {
      const container = this.playerContainer.getBoundingClientRect();
      const newWidth = container.width !== this.state.containerW;
      const newHeight = container.height !== this.state.containerH;
      const isPortrait = container.width < container.height;
      if (newWidth || newHeight) {
        this.checkSpaceForGist();             // check space for gist
        this.setPlayerControlType(container); // set control view type based on available space
        this.setState({
          containerW: container.width,
          containerH: container.height,
          isPortrait: isPortrait
        });
      }
    }
  }

  componentWillUnmount = () => {
    clearTimeout(this.skipTimeout);
    clearTimeout(this.controlsTimeout);
    clearTimeout(this.searchTimeout);
    clearTimeout(this.updatePlayerComponentSizeTimeout);

    clearInterval(this.runBufferLoaderCheck);
    clearInterval(this.getDuration);
    clearInterval(this.trackPlayerPosition);
    clearInterval(this.resumePlaybackiOS);
    clearInterval(this.viewTracker);
    clearInterval(this.reloadedPlay);

    window.removeEventListener("resize", this.checkSize, false);

    // remove video event listener
    if(this.video) {
      this.video.removeEventListener('error', this.onVideoError , false);
      this.video.removeEventListener('play', this.onVideoPlay, false);
    }
  };

  setPlayerControlType = (container) => {
  	// full control
    const spaceForFullControls = container.width >= playerConstants.PLAYER_MIN_WIDTH.FULL_CONTROLS;
    this.setState({ isShowFullControls: spaceForFullControls });

    // semi-full control
    const spaceForSemiFullControls = container.width > playerConstants.PLAYER_MIN_WIDTH.SEMI_FULL_CONTROLS;
    this.setState({ isShowSemiFullControls: spaceForSemiFullControls });

  	// single-tier or double-tier
    const spaceForSingleTier = (this.state.isSearchActive)
                                  ? container.width >= playerConstants.PLAYER_MIN_WIDTH.SINGLE_TIER_SEARCH  // search-active 2-tier early
                                  : container.width >= playerConstants.PLAYER_MIN_WIDTH.SINGLE_TIER;
    this.setState({ isShowDoubleTierControls: !spaceForSingleTier });
  };

  getMinHeight() {
    let minHeight = 0;
    if (this.playerContainer) {
      const container = this.playerContainer.getBoundingClientRect();
      // set min height for player based on audio or video source
      if (container.width < 400) {
        minHeight = (this.state.isVideo) ? 246 : 335;
      } else {
        minHeight = (this.state.isVideo) ? 220 : 300;
      }
    }
    return minHeight;
  }

  checkSpaceForGist = () => {
    if (this.playerContainer) {
      const container = this.playerContainer.getBoundingClientRect();
      let tooSmall;
      if (container.width <= playerConstants.PLAYER_MIN_WIDTH.BASIC_CONTROLS) {
        tooSmall = true;
      } else {
        tooSmall = container.height < this.getMinHeight();
      }

      this.setState({screenTooSmallForGist: tooSmall})
    }
  };

  setClouds = (cloudInfo) => {
    if ( cloudInfo ){
      const wordCount = 50;
      const clouds = generateClouds(wordCount, cloudInfo);
      this.setState({clouds: clouds})
    } else {
      this.setState({cloudInfo: true, clouds: []})
    }
  };

  // checks if video metadata is ready
  prepareVideoDuration = () => {
    this.getDuration = setInterval(() => {
      if (this.video && this.video.duration > 0) {

        // add video event listeners
        this.video.addEventListener('error', this.onVideoError , false);
        this.video.addEventListener('play', this.onVideoPlay, false);

        this.setState({ videoLoaded: true });
        clearInterval(this.getDuration)  // stops once duration ready and cloudInfo loaded
      }
    }, 5);
  };

  // invoked when the media shows error
  onVideoError() {
    this.setState({ forceMediaReload: true }, () => {
      if(this.state.videoIsPlaying) { // if video-is-playing, try to perform reload
        this.reloadSourceOnPlaybackStuck();
      }
    });
  }

  // invoked when the media is played
  onVideoPlay() {
    // if media needs to be reloaded
    if(this.state.forceMediaReload) {
      this.reloadSourceOnPlaybackStuck();
    }
  }

  // checks if the video has not progressed after some timeout, if so reloads the media and resumes playback
  reloadSourceOnPlaybackStuck = () => {
    // plays reloaded media from current-time after video is ready
    this.playReloadedSource = (currentTime) => {
      this.reloadedPlay = setInterval(() => {
        // if the video and its duration is ready
        if (this.video && this.video.duration > 0) {
          this.video.currentTime = currentTime; // set video to current time
          this.video.play();                    // play the video
          clearInterval(this.reloadedPlay);     // remove the interval once the playback starts

          this.setState({ forceMediaReload: false, showBufferingLoader: false });
        }
      }, 5);  // check every 5 ms
    };

    /*
     * [PATCH]
     * Access to 'Zoom' media sources are known to be inaccessible if paused for a long time
     * In such a case, re-load the media source to fix the issue.
     */
    const currentTime = this.video.currentTime;
    this.setState({ showBufferingLoader: true });   // show loading-buffer
    this.video.src = this.props.dat.contentUri;           // set the same media uri again
    this.playReloadedSource(currentTime);                 // resume playback at time once media is ready
  };

  // checks (every 1s) whether the buffering loader needs to be shown or not
  trackBufferingLoader = () => {
    const setLoadingBufferState = (state) => {
      if (state !== this.state.showBufferingLoader) {
        this.setState({showBufferingLoader: state});
      }
    };

    this.runBufferLoaderCheck = setInterval(() => {
      if (this.video && this.state.videoIsPlaying) {
        this.video.onwaiting = () => setLoadingBufferState(true);
        this.video.onplaying = () => setLoadingBufferState(false);
      } else {
        setLoadingBufferState(false);
        clearTimeout(this.runBufferLoaderCheck);
      }
    }, 1000);
  };

  // checks (every 1s) and updates position if position has changed (while video is playing or seek while pause)
  updatePlayerPositionTimerOnChange = () =>{
    this.trackPlayerPosition = setInterval(() => {
      if (this.video && this.state.videoIsPlaying) {
        let newPosition = 100 * (this.video.currentTime / this.video.duration);
        if( newPosition !== this.state.position) { this.setState({ position: newPosition }) }
      } else {
        clearTimeout(this.trackPlayerPosition);
      }
    }, 1000);
  };

  // sends increment video view count
  invokeIncrementVideoView = () => {
    let countAttempt = 0;
    const maxRetriesAttemptAllowed = 3;
    let viewIncrementRequestPending = false;

    this.viewTracker = setInterval(() => {
      if (!viewIncrementRequestPending) {
        viewIncrementRequestPending = true;

        // send the request to update the view count and exit
        incrementViewCount(this.props.videoId).then(res => {
          if (res === true) { clearInterval(this.viewTracker); } // if service acknowledges, then close interval
        });

        // if max retries exceeds, then close interval
        if (++countAttempt >= maxRetriesAttemptAllowed) { clearInterval(this.viewTracker); }
        viewIncrementRequestPending = false;
      }
    }, 5000); // checks every 5 seconds
  };

  // accepts a source object and checks if it is a video or audio
  static isVideo = (source) => source && source.contentType && (source.contentType.slice(0, 5) === "video");

  // This function fetches for timecloud information and loads it
  loadCloudInfo = () => {
    const {videoId, dat, version} = this.props;

    // seek gist if the source is available
    if (dat) {
      this.setState({ isVideo: Player.isVideo(dat) });

      // noinspection JSUnusedLocalSymbols
      getCloud(videoId, {version: version})
          .then(res => {
            let newCloud = {contents: res};
            const chapterCount = newCloud.contents.length;
            const startingChapter = this.getStartingChapter(newCloud);

            this.setState({
              cloudInfo: newCloud,            // cloud data
              chapterCount: chapterCount,     // total chapters
              currentChapter: startingChapter // chapter to start with
            });

            // invoke view increment once gist loads
            this.invokeIncrementVideoView();

            // gist-player loaded event : assumes that player was loaded and was awaiting gist
            store.dispatch(playerActions.onLoad());
          })
          .catch(error => {
            this.setState({cloudInfo: false});
          });
    }
  };

  /**
   * Selects the initial starting chapter on gist load
   *
   * @param cloudInfo the cloud information
   */
  getStartingChapter = (cloudInfo) => {
    let startingChapter = this.state.currentChapter;  // use default as fallback
    if( __isAvailable(cloudInfo) && __isAvailable(cloudInfo.contents)) {
      for (let i = 1; i < cloudInfo.contents.length; i++) {
        if(cloudInfo.contents[i-1].elements.length > 0) {
          startingChapter = i;
          break;
        }
      }
    }
    return startingChapter;
  };

  isiOSAndNotPrePlayed = () => !this.state.iosPrePlay && isIOS;

  updatePlayerPosition = debounce((position) => {
    if (position !== this.state.position) {
      this.setState({
        position: position,
        showThumbnail: !this.state.isVideo ||             // audio always shows the thumbnail
            (this.state.showThumbnail && position === 0)  // video shows thumbnail if playback hasn't started
      });

      /*
       * This has side-effects on iOS when the source has not been played before.
       * If the current time is played around before the source is played, then it causes the playback to start from the beginning irrespective of current time.
       * With this workaround, the UI (position-in-timeline/chapter) are updated, and the video elapsed timer is updated whenever the playback is resumed/initiated.
       */
      if (!this.isiOSAndNotPrePlayed()) {
        this.video.currentTime = this.video.duration * (position / 100);
      }

      // calculate current chapter based on
      let current = Math.ceil((position/100) * this.state.chapterCount);
      current === 0 && current++;
      current !== this.state.currentChapter && this.setState({currentChapter: current});
      this.updateCurrentChapter(current);
    }
  }, 7);

  /**
   * This action is pushed to CloudItems (words) and is invoked on [onClick]
   * @param {number} seconds The seconds elapsed on the video where the word occurs
   */
  resumeFromTime = debounce((seconds = 0) => {
    // update timer if the reported seconds is zero & position on the timeline is different
    if(seconds === 0 && this.state.position !== 0) {
      seconds = (this.state.position / 100) * this.video.duration;
    }

    const playFromTimer = (seconds) => {
      let position = (seconds / this.video.duration) * 100;
      if(position !== this.state.position) { this.setState({position: position}); }
      if(seconds !== this.video.currentTime) { this.video.currentTime = seconds; }
      this.playVideo();
    };

    playFromTimer(seconds);

    /*
    In iOS, if the video has not been played since being loaded and if we click a gist word,
    it doesn't play from the word timestamp but instead plays from the start.
    This is due to iOS only allowing initial playback on user interaction (eventHandler)
    This hack addresses it.

    The iosPrePlay state tracks whether the video has been played at all. On the first word click on iOS,
    the playFromTimer is executed twice - later after the video state (current position - start on iOS) is ready
    (1st one plays video from the start, 2nd one from the desired time)
    All request after the first word click just runs playFromTimer once.
     */
    if (this.isiOSAndNotPrePlayed()) {
      // start interval that checks if the desired video state is ready
      this.resumePlaybackiOS = setInterval(() => {
        if (this.video.readyState > 1) {  // video state - once current playback position is available
          playFromTimer(seconds);                     // once available re-play from word
          this.setState({iosPrePlay: true});    // set the state to true
          clearInterval(this.resumePlaybackiOS);      // stop once playback position adjusted
        }
      }, 5);  // check every 5 ms
    }
  }, 7);

  playVideo = () => {
    this.setState({
      videoIsPlaying: true,
      showThumbnail: !this.state.isVideo,   // thumbnail only shows for audio when playing
    }, () => {
      this.trackBufferingLoader();              // start tracking buffer
      this.updatePlayerPositionTimerOnChange(); // start current player position tracker
    });
    this.video && this.video.play();

    if (!this.state.hideControlsTimeout) {
      setTimeout(() =>  this.hideControlsTimeout(), 2000);
    }
  };

  pauseVideo = () => {
    this.video.pause();
    this.setState({videoIsPlaying: false});
  };

  isForwardSkippable = (time = this.video.currentTime) => time < this.video.duration;

  isBackwardSkippable = (time = this.video.currentTime) => time > 0;

  skipForwards = () => {
    if (this.isForwardSkippable()) {
      const isFullForwardSkip = this.isForwardSkippable(this.video.currentTime + SEEK_SKIP.SIZE);
      this.video.currentTime = isFullForwardSkip
          ? this.video.currentTime + SEEK_SKIP.SIZE
          : this.video.duration;
    }
    store.dispatch( playerActions.onSkipBtn(true) ); // skip forward event
  };

  skipBackwards = () => {
    if (this.isBackwardSkippable()) {
      const isFullBackwardSkip = this.isBackwardSkippable(this.video.currentTime - SEEK_SKIP.SIZE);
      this.video.currentTime = (isFullBackwardSkip)
          ? this.video.currentTime - SEEK_SKIP.SIZE
          : 0;
    }
    store.dispatch( playerActions.onSkipBtn(false) ); // skip backward event
  };

  changePlayback = (value) => {
    this.video.playbackRate = value;
  };

  changeVolume = (volume) => {
    this.video.volume = parseFloat(volume);
    this.video.muted = (volume === 0);      // apply muted property if the volume is 0
  };

  updateCurrentChapter = (current) => {
    if (current !== this.state.currentChapter) {
      this.peekControls();
      this.setState({currentChapter: current})
    }
  };

  showWordOnTimeline = (wordTime) => {
    this.setState({wordTimelinePosition: this.getTickPosition(wordTime)})
  };

  hideWordOnTimeline = () => {
    this.setState({wordTimelinePosition: null})
  };

  toggleIsScrubbing = () => {
    this.setState({isScrubbing: !this.state.isScrubbing})
  };

  clearIsScrubbing = () => {
    this.state.isScrubbing && this.setState({isScrubbing: false})
  };

  handleMouseEnter = () => {
    this.setState({isHovered: true})
    this.peekControls();
  };

  handleMouseLeave = () => {
    this.setState({isHovered: false});
    this.clearIsScrubbing()
    this.hideControls();
  };

  setSeekSkipTimer = (side) => {
    clearTimeout(this.skipTimeout);                   // clear skip timer if set
    const nextSkip = this.state.seekSkipCounter + 1;  // find the total skip 'increment'

    if (side === SEEK_SKIP.BACKWARD) {
      this.setState({showSkipLeft: true, seekSkipCounter: nextSkip});
      this.skipTimeout = setTimeout(() =>
          this.setState({showSkipLeft: false, seekSkipCounter: 0}), 1250);

    } else if (side === SEEK_SKIP.FORWARD) {
      this.setState({showSkipRight: true, seekSkipCounter: nextSkip});
      this.skipTimeout = setTimeout(() =>
          this.setState({showSkipRight: false, seekSkipCounter: 0}), 1250);
    }
  };

  handleVideoSeekSkipClick = (event, side) => {
    // backward-skip is conditional as currentTime could be a moving target
    const isBackwardSkip = () => {
      return (this.state.videoIsPlaying)
          ? this.isBackwardSkippable(this.video.currentTime - SEEK_SKIP.SIZE)
          : this.isBackwardSkippable();
    };

    if (side === SEEK_SKIP.BACKWARD && isBackwardSkip()) {
      this.skipBackwards();
      this.setSeekSkipTimer(side);
    } else if(side === SEEK_SKIP.FORWARD && this.isForwardSkippable()){
      this.skipForwards();
      this.setSeekSkipTimer(side);
    }
  };

  handleVideoDoubleClick = (event) => {
    const boundingRect = this.video.getBoundingClientRect();
    const isLeftSided = event.pageX-boundingRect.left < (boundingRect.right - boundingRect.left)/2;
    if (isLeftSided) {
      this.skipBackwards();
      this.setSeekSkipTimer(SEEK_SKIP.BACKWARD);
    } else {
      this.skipForwards();
      this.setSeekSkipTimer(SEEK_SKIP.FORWARD);
    }
  };

  peekControls = () => {
    this.setState({peekControls: true});
  };

  hideControls = () => {
    if (this.state.videoIsPlaying && this.state.hideControlsTimeout) {
      this.setState({peekControls: false});
    }
  };

  hideControlsTimeout = () => {
    if (!this.state.isHovered) {
      this.setState({peekControls: false, hideControlsTimeout: true});
    } else {
      this.setState({hideControlsTimeout: true});
    }
  }

  gistLoaded = () => {
    return this.state.videoLoaded && this.state.cloudInfo
  };

  showControls = () => {
    const {allowHideGist, videoIsPlaying, peekControls, isVideo} = this.state;
    return !isVideo || !allowHideGist || !videoIsPlaying || peekControls;
  };

  toggleTableOfContents = () => {
	  this.setState({showTableOfContents: !this.state.showTableOfContents})
  };

  toggleGist = () => {
    const {allowHideGist} = this.state;

    if (allowHideGist) {
      this.setState({showGist: !this.state.showGist});
    }
  };

  setEnableHideGist = (enable) => {
    const {allowHideGist} = this.state;

    if (enable !== allowHideGist) {
      this.setState({allowHideGist: enable});
    }
  };

  goToChapter = (chapterNumber) => {
    this.toggleTableOfContents();
    this.updateCurrentChapter(chapterNumber);
  };

  toggleFullScreen = () => {
    // register event
    if (this.state.isFullScreen) {
      store.dispatch(playerActions.onFullViewChange(false));  // player exit full screen onClick event
    } else {
      store.dispatch(playerActions.onFullViewChange(true));   // player full screen onClick event
    }

    // noinspection JSUnresolvedVariable
    if (fscreen.fullscreenEnabled) {
      this.setState({isFull: !this.state.isFull});
    } else {
      this.setState({isFullScreen: !this.state.isFullScreen}, () => {
        this.toggleiOSFullscreenStyle();
      });
    }

    if (isMobile) {
      this.pauseVideo();
    }
  };

  toggleiOSFullscreenStyle = () => {
    if(this.playerContainer) {
      if (this.state.isFullScreen) {
        this.playerContainer.style.position = 'fixed';
        this.playerContainer.style.top = '0px';
        this.playerContainer.style.left = '0px';

        this.disableBodyScroll();
        this.hideZenChat();
      } else {
        this.playerContainer.style.position = 'relative';
        this.playerContainer.style.top = null;
        this.playerContainer.style.left = null;

        this.reEnableBodyScroll();
        this.showZenChat();
      }
    }
  };

  disableBodyScroll = () => {
    document.body.style.overflow = 'hidden';
  }

  reEnableBodyScroll = () => {
    document.body.style.overflow = '';
  }

  fullscreen = () => {
    this.toggleFullScreen();
  };

  getGistPlayerRect() {
    if (this.playerContainer) {
      return this.playerContainer.getBoundingClientRect();
    }
  }

  toggleSearch = (clearResults=true) => {
    this.setState({isSearchActive: !this.state.isSearchActive}, () => {
      // if search is turned off
      if(!this.state.isSearchActive) {
        if(clearResults) {  // if clear query and results
          this.setState({ searchQuery: '', searchResults: null, searchTimelinePositions: [] });
        }
        this.setState({ isTranscriptError: false });  // clear error message once search inactive
        store.dispatch(playerActions.onSearchChange(false));  // analytics
      } else {
        store.dispatch(playerActions.onSearchChange(true));   // analytics
      }
    });
  };

  handleSearch = (query) => {
    // if trimmed query is same as current, then avoid performing search
    const isTrimmedQuerySame = (str1, str2) => str1.trim() === str2.trim();
    if(isTrimmedQuerySame(this.state.searchQuery, query)) { return; }

    clearTimeout(this.searchTimeout);
    this.setState({ searchQuery: query, isSearchOngoing: true }, ()=> {
      (this.state.searchQuery === "")
        ? this.setState({ isSearchOngoing: false }) // if empty
        : this.searchTimeout = setTimeout(() => this.prepareSearch(), 300); // 300 ms delay
    });
  };

  prepareSearch = () => {
    if(__isAvailable(this.state.transcriptData)) {
      this.performSearch();
    } else {
      // Avoid sending multiple requests. Once transcript fetched, perform-search is invoked
      if(this.state.isFetchingTranscript) { return; }
      this.setState({ isFetchingTranscript: true });
      
      getTranscript(this.props.videoId)
          .then(transcript => {
            const transcriptIndex = prepareIndex(transcript.words)
            this.setState({ transcriptData: transcript.words, transcriptIndex: transcriptIndex, isTranscriptError: false, isFetchingTranscript: false }
                ,() => this.performSearch()
            )
          })
          .catch(() => {
            this.setState( { isTranscriptError: true, isSearchOngoing: false, isFetchingTranscript: false })
          });
    }
  };

  performSearch = () => {
    const index = this.state.transcriptIndex;   // transcript index
    const fullData = this.state.transcriptData; // full data
    const query = this.state.searchQuery;       // search query

    store.dispatch(playerActions.onSearchPerform());  // analytics

    const results = searchTranscript(index, fullData, query);
    const data = this.assignTickPositionToSearchResults(results);
    const tickPositions = data.hits.map(h => h.position);
    this.setState({
      searchResults: data,
      searchTimelinePositions: tickPositions,
      searchCurrentHit: 1,
      isSearchOngoing: false,
    });
  };

  setCurrentSearchHit = (hitIndex) => {
    this.setState({searchCurrentHit: hitIndex});
  };

  getTotalVideoDuration = () => (this.video && this.video.duration > 0) ? this.video.duration : 0;

  getCurrentVideoTime = () => {
    if(this.video && this.video.duration > 0) {
      // if current time is 0, then base it off position on the timeline
      return (this.video.currentTime > 0)
          ? this.video.currentTime
          : ((this.state.position / 100) * this.video.duration);
    } else {
      return 0;
    }
  }

  getTickPosition = (time) => {
    if(time == null) { return null; }
    return (time / this.getTotalVideoDuration()) * 100;
  };

  assignTickPositionToSearchResults = (searchData) => {
    searchData.hits.map((hit) => {
      hit.position = this.getTickPosition(hit.time);
    });
    return searchData;
  };

  // Zen Chat Show/Hide

  // hide chat by setting z-index to arbitrary negative number
  hideZenChat = () => this.setZenChatZValue(-999999)

  // show chat by setting z-index to the default value
  showZenChat = () => {
    if(!this.props.isEmbedded) { this.setZenChatZValue(999999) }
  }

  // set zen-chat z-index value
  setZenChatZValue = (value) => {
    const scriptId = "zen-chat-z-index-gist-player"                        // id for script to control z-index of zen-chat

    // find and remove script with the zen-chat id, if available
    const scriptNode = document.getElementById(scriptId)
    if(scriptNode) {
      scriptNode.parentNode.removeChild(scriptNode);
    }

    // create script to change the z-index of zen chat widget
    const script = document.createElement("script");
    script.type = 'text/javascript';
    script.id = scriptId;
    script.async = true;
    script.innerHTML = "zE('messenger:set', 'zIndex', " + value + ");"  // set z-index value
    document.body.appendChild(script);
  }

  // End of Zen Chat Show/Hide

  /// RENDER ###################################################################

  render() {
    const showGistSlider = this.state.showGist && !this.state.screenTooSmallForGist;
    const showGistTooSmall = this.state.showGist && this.state.screenTooSmallForGist;
    const showTimeline = this.state.videoLoaded && !showGistTooSmall;
    const mobilePlayIcon = this.state.videoIsPlaying ? "pause" : "expand-arrows-alt";
    const seekSkipSeconds = SEEK_SKIP.SIZE * this.state.seekSkipCounter;                 // (skip-size * no-of-presses) seconds
    const t = i18next.t;

    const totalVideoDuration = this.getTotalVideoDuration();
    const currentVideoTime = this.getCurrentVideoTime();
    const showSearchResults = this.state.isSearchActive && this.state.searchQuery !== '';

    return (
        <PlayerWrapper height={this.state.isVideo ? "100%" : "auto"}>

          {this.gistLoaded() && showGistTooSmall &&
              <TooSmall>
                <MobilePlayButton onClick={() => this.fullscreen()}>
                  <FontAwesomeIcon icon={mobilePlayIcon} size="2x" color="#E3E3E3" />
                </MobilePlayButton>
            </TooSmall>
          }

          <FullScreen
            enabled={this.state.isFull}
            ref={elm => {this.fsElm = elm}}
            onChange={isFull => this.setState({isFull: isFull, isFullScreen: isFull})}
          >

            <StyledPlayer
                ref={elm => this.playerContainer = elm}
                minHeight={this.getMinHeight() + BOX_SHADOW_SIZE}
                className="player"
                showGist={this.state.showGist}
                onMouseEnter={() => this.handleMouseEnter()}
                onMouseLeave={() => this.handleMouseLeave()}
            >

              {this.props.dat &&
                <Video
                    playsInline
                    ref={c => (this.video = c)}
                    preload="auto"
                    marginTop={this.state.isVideo ? 0 : BOX_SHADOW_SIZE}
                    onDoubleClick={this.handleVideoDoubleClick}>
                  <source src={this.props.dat.contentUri} />
                </Video>
              }

              {(this.state.showSkipLeft || this.state.showSkipRight) &&
              <>
              <DarkBackground/>
              <SkipAction left
                          onClick={(e) => this.handleVideoSeekSkipClick(e, SEEK_SKIP.BACKWARD)}
                          visable={this.state.showSkipLeft}>
                <SkipLabel left>
                  <Arrows left>{'<<<'}</Arrows>
                  <span>{t('[seekSkipSeconds] seconds',{seekSkipSeconds: seekSkipSeconds})}</span>
                </SkipLabel>
              </SkipAction>
              <SkipAction right
                          onClick={(e) => this.handleVideoSeekSkipClick(e, SEEK_SKIP.FORWARD)}
                          visable={this.state.showSkipRight}>
                <SkipLabel right>
                  <Arrows right>{">>>"}</Arrows>
                  <span>{t('[seekSkipSeconds] seconds',{seekSkipSeconds: seekSkipSeconds})}</span>
                </SkipLabel>
              </SkipAction>
              </>
              }

              {this.state.showThumbnail && this.props.dat &&
                  <Thumbnail
                      thumbnailUri={this.props.dat.thumbnailUri}
                      marginTop={this.state.isVideo ? 0 : BOX_SHADOW_SIZE}
                      backgroundSize="contain"
                  />
              }

              {this.gistLoaded() &&
                <Controls
                  show={this.showControls()}
                  showGist={showGistSlider}
                  isVideo={this.state.isVideo}
                  showSearchResults={showSearchResults}
                >

                  {showGistSlider && this.state.clouds.length > 0 &&
                  <ChapterSlider
                      // // for slider
                      clouds={this.state.clouds}
                      updateCurrentChapter={this.updateCurrentChapter}
                      currentChapter={this.state.currentChapter}
                      containerW={this.state.containerW}
                      containerH={this.state.containerH}
                      // for ChapterSlider
                      isVideo={this.state.isVideo}
                      // for gistItem
                      playWord={this.resumeFromTime}
                      showWordOnTimeline={this.showWordOnTimeline}
                      hideWordOnTimeline={this.hideWordOnTimeline}
                      getGistPlayerRect={this.getGistPlayerRect}
                      setEnableHideGist={this.setEnableHideGist}
                  />
                  }

                  {showSearchResults &&
                  <Search
                      parentContainerW={this.state.containerW}
                      results={this.state.searchResults}
                      currentHit={this.state.searchCurrentHit}
                      setCurrentHit={this.setCurrentSearchHit}
                      toggleSearch={this.toggleSearch}
                      resumeFromTime={this.resumeFromTime}
                      isTranscriptError={this.state.isTranscriptError}
                      gistShown={showGistSlider}
                  />
                  }

                  {showTimeline &&
                  <Timeline
                      update={this.updatePlayerPosition}
                      position={this.state.position}
                      chapterCount={this.state.chapterCount}
                      showGist={this.state.showGist}
                      toggleGist={this.toggleGist}
                      disableShowHide={!this.state.isVideo}
                      currentChapter={this.state.currentChapter}
                      playVideo={this.resumeFromTime}
                      pauseVideo={this.pauseVideo}
                      skipBackwards={this.skipBackwards}
                      skipForwards={this.skipForwards}
                      changePlayback={this.changePlayback}
                      changeVolume={this.changeVolume}
                      videoIsPlaying={this.state.videoIsPlaying}
                      toggleIsScrubbing={this.toggleIsScrubbing}
                      isScrubbing={this.state.isScrubbing}
                      totalDuration={totalVideoDuration}
                      currentTime={currentVideoTime}
                      wordTimelinePosition={this.state.wordTimelinePosition}
                      showTOC={this.toggleTableOfContents}
                      toggleFullScreen={this.toggleFullScreen}
                      isFullScreen={this.state.isFullScreen}
                      screenTooSmallForGist={this.state.screenTooSmallForGist}
                      cloudCount={this.state.clouds.length}
                      fsElm={this.playerContainer}
                      showFullControls={this.state.isShowFullControls}
                      showSemiFullControls={this.state.isShowSemiFullControls}
                      showDoubleTierControls={this.state.isShowDoubleTierControls}
                      isSearchActive={this.state.isSearchActive}
                      toggleSearch={this.toggleSearch}
                      searchQuery={this.state.searchQuery}
                      handleSearch={this.handleSearch}
                      searchTimelinePositions={this.state.searchTimelinePositions}
                      searchCurrentHit={this.state.searchCurrentHit}
                      isSearchOngoing={this.state.isSearchOngoing}
                  />
                  }
                </Controls>
              }

              {this.state.showTableOfContents &&
                <TableOfContents
                  chapters={this.state.clouds}
                  close={this.toggleTableOfContents}
                  containerW={this.state.containerW}
                  containerH={this.state.containerH}
                  goToChapter={this.goToChapter}
                  show={this.state.showTableOfContents}
                />
              }

              {/* if the source data is not loaded and error message exists, then show it*/}
              {!this.props.dat && this.props.errorMessage &&
              <ErrorMessage> {this.props.errorMessage} </ErrorMessage>
              }

              {this.state.showBufferingLoader &&
              <LoaderContainer videoIsPlaying={this.state.videoIsPlaying} >
                <DarkBackground/>
                <CustomLinearProgress />
              </LoaderContainer>
              }

            </StyledPlayer>
          </FullScreen>
        </PlayerWrapper>
    );
  }
}

export default Player;
